// @flow
import * as React from 'react'

import { Audio } from '../index'
import { useAudioPreviewStyles } from './styles'

type AudioPreviewProps = {
  extension?: 'wav' | 'mp3',
  audioSrc: Blob,
  inputElement: React.Node
}

const AudioPreview = ({ audioSrc, inputElement, extension = 'wav' }: AudioPreviewProps) => {
  const classes = useAudioPreviewStyles()

  return (
    <div className={classes.container}>
      <div className={classes.audio}>
        <Audio src={audioSrc} type="blob" />
      </div>
      <div className={classes.inputContainer}>
        {inputElement}
        <div className={classes.propertiesContainer}>
          <b>.{extension}</b>&nbsp;({Math.round(audioSrc.size / 1024)} kB)
        </div>
      </div>
    </div>
  )
}

export default AudioPreview
